<template>
	<base-form class="password-forgot-form">
		<template #header>
			<h2 class="password-forgot-form__title">
				Set your
				<br />
				new password
			</h2>
			<p class="password-forgot-form__description">
				You have requested to reset your password.
				<br />
				Please fill in the form below to proceed.
			</p>
		</template>
		<form-element v-bind="{ errors, model, loading }" @submit="onSubmit">
			<form-item label="E-mail" :name="'email'" :rules="[required, email]">
				<input
					v-model="model.email"
					class="password-forgot-form__input"
					name="email"
					type="email"
					autocomplete="login-email"
				/>
			</form-item>
			<form-item label="New password" :name="'password'" :rules="[required, minLength(8)]">
				<input
					v-model="model.password"
					class="password-forgot-form__input"
					name="password"
					type="password"
					autocomplete="none"
				/>
			</form-item>
			<form-item
				label="Confirm password"
				:name="'password_confirmation'"
				:rules="[required, same(() => model.password)]"
			>
				<input
					v-model="model.password_confirmation"
					class="password-forgot-form__input"
					name="password_confirmation"
					type="password"
					autocomplete="none"
				/>
			</form-item>

			<template #buttons>
				<router-link :to="{ name: 'login' }" class="link">Back to login</router-link>

				<base-button secondary type="submit" v-bind="{ loading }">Submit</base-button>
			</template>
		</form-element>
	</base-form>
</template>

<script lang="ts">
import { Dictionary } from 'lodash';
import { defineComponent, PropType } from 'vue';

import BaseForm from '@/components/base/form/BaseForm.vue';
import FormElement from '@/components/form/FormElement.vue';
import FormItem from '@/components/form/FormItem.vue';
import { email, minLength, required, same } from '@/tools/validation';

export default defineComponent({
	components: {
		BaseForm,
		FormElement,
		FormItem,
	},

	props: {
		loading: {
			type: Boolean,
			default: false,
		},

		token: {
			type: String,
			required: true,
		},

		errors: {
			type: Object as PropType<Dictionary<string[]>>,
			default: () => ({}),
		},
	},

	emits: ['submit'],

	data() {
		return {
			model: {
				email: '',
				password: '',
				password_confirmation: '',
				token: this.token,
			},
		};
	},

	methods: {
		email,
		required,
		minLength,
		same,

		onSubmit() {
			const { email, password, password_confirmation } = this.model;
			const { token } = this;

			this.$emit('submit', {
				email,
				password,
				password_confirmation,
				token,
			});
		},
	},
});
</script>

<style lang="scss">
.password-forgot-form {
	color: $color-light;

	&__title {
		@include heading-1;
	}

	&__description {
		margin: 2.4rem 0 0;
		font-size: 1.8rem;
	}

	.form-item {
		label {
			color: inherit;
		}

		input {
			&,
			&:focus,
			&:-webkit-autofill,
			&:-webkit-autofill:active,
			&:-webkit-autofill:hover,
			&:-webkit-autofill:focus {
				color: $color-dark !important;
				font-size: $font-size-input;
				background-color: $color-light !important;
			}
		}
	}
}
</style>
